import { render, staticRenderFns } from "./PendingReceiveList.vue?vue&type=template&id=67b697ba"
import script from "./PendingReceiveList.vue?vue&type=script&lang=js"
export * from "./PendingReceiveList.vue?vue&type=script&lang=js"
import style0 from "./PendingReceiveList.vue?vue&type=style&index=0&id=67b697ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports